export default [
  {
    path: "/",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "Home",
        path: "", 
        component: () => import("./pages/Home")
      },
      {
        name: "Error",
        path: "error",
        component: () => import("./pages/Error")
      }
    ]
  }
];
